<script>
import { Line } from 'vue-chartjs'
import 'chartjs-plugin-streaming'

export default {
    extends: Line,
    props: {
        pushDataFn: {
            type: Function,
            required: true
        },
        chartBgColor: {
            type: String,
            required: false,
            default: '#ccc'
        }
    },
    mounted() {
        this.renderChart({
            datasets: [{
                label: 'Bitrate (Kbps)',
                data: [],
                borderColor: 'gray',
                backgroundColor: 'gray',
            },]
        }, {
            responsive: true,
            maintainAspectRatio: true,
            scales: {
                xAxes: [{
                    type: 'realtime',
                    realtime: {
                        delay: 2000,
                        onRefresh: chart => {
                            chart.data.datasets[0].backgroundColor = this.chartBgColor + '80'; // Adding 80 hex for 50% opacity
                            chart.data.datasets[0].borderColor = this.chartBgColor;
                            this.pushDataFn(chart.data.datasets[0].data);
                            chart.update();
                        }
                    }
                }],
                yAxes: [{
                    ticks: {
                        min: 0,
                        max: 3000,
                        stepSize: 1000,
                        callback: function (value, index, ticks) {
                            return parseInt((value / 1000)) + 'k';
                        }
                    },
                }],

            },

        })
    }
}
</script>